import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from '../locales/en.json';
import ar from '../locales/ar.json';

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
  });

// Apply language-specific settings
const applyLanguageSettings = (lang: string) => {
  const isRtl = lang === 'ar';
  document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  document.documentElement.lang = lang;
  
  // Update font based on language
  if (isRtl) {
    document.documentElement.style.setProperty('--font-family', "'Cairo', 'Tajawal', system-ui, sans-serif");
  } else {
    document.documentElement.style.setProperty('--font-family', "'Inter', system-ui, sans-serif");
  }
};

// Apply on initial load
applyLanguageSettings(i18n.language);

// Listen for language changes
i18n.on('languageChanged', applyLanguageSettings);

export default i18n;

/**
 * Change language and persist to localStorage
 */
export function changeLanguage(lang: 'en' | 'ar') {
  i18n.changeLanguage(lang);
  localStorage.setItem('language', lang);
  applyLanguageSettings(lang);
}

/**
 * Get current language
 */
export function getCurrentLanguage(): 'en' | 'ar' {
  return (i18n.language || 'en').startsWith('ar') ? 'ar' : 'en';
}

/**
 * Check if current language is RTL
 */
export function isRtl(): boolean {
  return getCurrentLanguage() === 'ar';
}
